module.exports = __webpack_public_path__ + "img/bottom-bg.baff84a4.png";